<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'Users by Lot Number'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>

            <ng-container *ngIf="this.userList.length > 0">
    <div style="margin-top:30px;"></div>
    <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;margin-bottom:10px;">
        Number of Users For Lot: {{userList.length}}    

        
    </div>
    <igx-grid #gridAgingReport id="gridAgingReport" [igxPreventDocumentScroll]="true" [data]="userList"  [height]="'720px'" [width]="'100%'" [autoGenerate]="false"
    [primaryKey]="'invoiceNumber'" [cellSelection]="'none'" [rowEditable]="false">

    <igx-column field="userName" header="User Name"  width="250px" [sortable]="true"></igx-column>
    <igx-column field="displayName" header="Display Name" width="500px" [sortable]="true" ></igx-column>

    <igx-grid-toolbar>
    <igx-grid-toolbar-actions>
    <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
    <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
    <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
    </igx-grid-toolbar>

    <!-- <igx-action-strip #actionStrip1>
        <igx-grid-pinning-actions></igx-grid-pinning-actions>
        <igx-grid-editing-actions></igx-grid-editing-actions>
    </igx-action-strip> -->

</igx-grid>


</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>

